import React from 'react';
import { Chart } from '../../components/Chart';
import { Table } from '../../components/Table';
import { useTheme } from '../../contexts/ThemeContext';

export const AverageCheckPage: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>Средний чек</h2>
      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
        <Chart
          theme={theme}
          type="line"
          title="Динамика среднего чека"
          data={[
            { label: 'Янв', value: 401 },
            { label: 'Фев', value: 418 },
            { label: 'Мар', value: 415 },
            { label: 'Апр', value: 428 }
          ]}
        />
        <Chart
          theme={theme}
          type="bar"
          title="Количество чеков"
          data={[
            { label: 'Янв', value: 2456, color: '#003497' },
            { label: 'Фев', value: 2134, color: '#4d7fff' },
            { label: 'Мар', value: 2789, color: '#80a3ff' },
            { label: 'Апр', value: 2567, color: '#b3ccff' }
          ]}
        />
      </div>
      <Table
        title="Статистика среднего чека по месяцам"
        columns={[
          { key: 'month', title: 'Месяц', width: '20%' },
          { key: 'transactions_count', title: 'Кол-во чеков', width: '20%' },
          { key: 'total_revenue', title: 'Общая сумма, сом', width: '25%' },
          { key: 'average_check', title: 'Средний чек, сом', width: '25%' },
          { key: 'growth', title: 'Рост %', width: '10%' }
        ]}
        data={[
          { id: '1', month: 'Январь 2024', transactions_count: '2,456', total_revenue: '985,400', average_check: '401.13', growth: '+12.5%', is_deleted: false },
          { id: '2', month: 'Февраль 2024', transactions_count: '2,134', total_revenue: '892,150', average_check: '418.22', growth: '+4.3%', is_deleted: false },
          { id: '3', month: 'Март 2024', transactions_count: '2,789', total_revenue: '1,156,780', average_check: '414.76', growth: '-0.8%', is_deleted: false },
          { id: '4', month: 'Апрель 2024', transactions_count: '2,567', total_revenue: '1,098,234', average_check: '427.89', growth: '+3.2%', is_deleted: false }
        ]}
        theme={theme}
        readOnly={true}
      />
    </div>
  );
};
